var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShuffle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.1667H4.4975C5.16743 14.1667 5.82748 14.0051 6.42168 13.6956C7.01587 13.3862 7.52669 12.9381 7.91083 12.3892L8.05833 12.1784M11.1083 7.82254L11.2558 7.61087C11.64 7.06201 12.1508 6.61387 12.745 6.30444C13.3392 5.99501 13.9992 5.83342 14.6692 5.83337H17.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.33337L17.5 5.83337L15 8.33337",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.83337H4.4975C5.16743 5.83342 5.82748 5.99501 6.42168 6.30444C7.01587 6.61387 7.52669 7.06201 7.91083 7.61087L11.2558 12.3892C11.64 12.9381 12.1508 13.3862 12.745 13.6956C13.3392 14.0051 13.9992 14.1667 14.6692 14.1667H17.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.6666L17.5 14.1666L15 11.6666",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/shuffle.ed1145628cb349a152b91ba3fd2072e0.svg";
export { ForwardRef as ReactComponent };